// @ vendors
const { Promise } = require('es6-promise');
// @ constants
const actionTypes = require('../insuranceConstants/actionTypes');
const { DOCUMENT_TYPES } = require('../insuranceConstants/insuranceRequestHome');
// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, base64ToBlob } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');

const docTypeKeys = {
    [DOCUMENT_TYPES.POLICY]: 'profileInsurances-policy',
    [DOCUMENT_TYPES.BUDGET]: 'profileInsurances-budget',
    [DOCUMENT_TYPES.PRODUCT_INFORMATION]: 'insuranceRequestHome-step5LinkProductInformation',
    [DOCUMENT_TYPES.PRE_POLICY]: 'profileInsurances-prePolicy',
};

const requestContractedPoliciesInProgress = () => ({
    type: actionTypes.FETCH_CONTRACTED_POLICY_REQUEST
});

const requestContractedPoliciesSuccess = (data) => ({
    type: actionTypes.FETCH_CONTRACTED_POLICY_SUCCESS,
    payload: {
        data
    }
});

const requestContractedPoliciesFailure = (error) => ({
    type: actionTypes.FETCH_CONTRACTED_POLICY_FAILURE,
    payload: {
        error
    }
});

const requestContractedPdfProgress = (docType, documentDownloadingPolicyNumber) => ({
    type: actionTypes.FETCH_CONTRACTED_POLICY_PDF_REQUEST,
    payload: {
        docType,
        documentDownloadingPolicyNumber
    }
});

const requestContractedPdfFinished = docType => ({
    type: actionTypes.FETCH_CONTRACTED_POLICY_PDF_FINISHED,
    payload: {
        docType
    }
});


const requestContractedPolicyDocumentation = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().insurancesProfileDocumentation.get('isFetching');
    if (!isAlreadyFetching) {
        return new Promise(() => {

            dispatch(requestContractedPoliciesInProgress());

            APIGet(dispatch, apiURLBuilder.getURL('insuranceRequestContractedDocuments')).then(
                response => dispatch(requestContractedPoliciesSuccess(response)),
                error => dispatch(requestContractedPoliciesFailure(error))
            );
        });
    }
};

const getContractedDocument = (docType, documentDownloadingPolicyNumber, policyVersion) => (dispatch) => {
    const requestData = {
        query: {
            policyNumber: documentDownloadingPolicyNumber,
            policyVersion: policyVersion,
            documentType: docType,
            language: getLanguage().toUpperCase()
        }
    };
    dispatch(requestContractedPdfProgress(docType, documentDownloadingPolicyNumber));
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestProductDetailContratedDocument'),
        requestData
    )
        .then(response => {
            const { data } = response;
            const { contentType } = data
            const base64string = `data:${contentType};base64,${data.base64}`;
            const b64toBlobResponse = base64ToBlob(base64string)
            download(b64toBlobResponse, `${formatText(docTypeKeys[docType])}.pdf`, contentType);
            dispatch(requestContractedPdfFinished(docType));
        })
        .catch(() => dispatch(requestContractedPdfFinished(docType)));
};

module.exports = {
    requestContractedPolicyDocumentation,
    getContractedDocument
};
